import React from 'react';
import { UnidadeContext } from './../../../Providers/unidadeProviders';
import { TextField, Typography, Grid, Box, Fade } from '@material-ui/core';
import { useSnackbar } from 'notistack';
import Service from './../../../service';
import Autocomplete from '../../../Components/Autocomplete';
import ResponsiveDialog from '../../../Components/Dialog';

const service = Service.getInstance();

function Selecao() {

  const { enqueueSnackbar } = useSnackbar();

  const { setChecked, state, setState } = React.useContext(UnidadeContext);

  const [servicos, setServicos] = React.useState([]);
  const [observacao, setObservacao] = React.useState('');

  const servico = state.servico_id;

  React.useEffect(() => {

    const load = async () => {

      try {

        const response = await service.get(`servicos?params=${Boolean(state.tipo_atendimento)}`)

        const { data } = response;

        setServicos(data)

      } catch (error) {
        enqueueSnackbar(error.response.statusText, { variant: 'error' });
      }

    }

    load()

  }, []);

  React.useEffect(() => {

    if (servico) {
      const observacoes = servicos.find(item => item.id === state.servico_id)?.observacoes;
      setObservacao(observacoes);
      return
    }

    setObservacao('');

  }, [servico]);

  React.useEffect(() => {
    const verificaServico = () => {
      state.servico_id === '' ? setChecked(false) : setChecked(true);
    }
    verificaServico();
  }, [state, setChecked]);

  return (

    <Fade in={true} timeout={700}>

      <Grid container spacing={2}>

        <Grid item xs={12}>

          <Autocomplete lang={servicos} />

          {/* <Typography component="div" align="justify" color="error">
            <Box ml={0.5} pt={1} fontSize={12}>{observacao}</Box></Typography> */}

          {observacao && <Box mt={1}><ResponsiveDialog message={observacao} /></Box>}

        </Grid>

        <Grid item xs={12}>

          <Typography variant="inherit" gutterBottom>
            Caso nencessário, nos informe mais detalhes do seu atendimento (opcional)
          </Typography>

          <TextField
            variant="outlined"
            margin="normal"
            fullWidth
            id="descricao_atendimento"
            label="Mais informações"
            name="descricao_atendimento"
            size="small"
            multiline
            rows={3}
            value={state.descricao_atendimento}
            placeholder="Descreva a sua solicitação"
            onChange={(e) => setState({ ...state, 'descricao_atendimento': e.target.value })}
          >

          </TextField>

        </Grid>

      </Grid>

    </Fade>
  );
}

export default React.memo(Selecao);